// base
import React, { forwardRef, useState } from 'react';

// style
import { StyledBasicPasswordV2 } from './style';

// libraries
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { InputAdornment, TextField, TextFieldVariants, type TextFieldProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';

interface BasicPasswordV2Props extends Omit<TextFieldProps, 'onChange'> {
  variant?: TextFieldVariants;
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BasicPasswordV2 = forwardRef<HTMLInputElement, BasicPasswordV2Props>((props, ref) => {
  const { label, required, onChange, ...rest } = props;

  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <StyledBasicPasswordV2>
      {label && (
        <span>
          {label}
          {required && <span className="required">*</span>}
        </span>
      )}

      <TextField
        type={showPassword ? 'text' : 'password'}
        onChange={handleChange}
        inputRef={ref}
        InputProps={{
          startAdornment: null,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }}
        {...rest}
      />
    </StyledBasicPasswordV2>
  );
});

BasicPasswordV2.displayName = 'BasicPasswordV2';
